// extracted by mini-css-extract-plugin
export default {"idpComment":"IdpComments_idpComment__0NOA5"};